import { objectUtils } from "@cayo/shared/utils/object";

const COMMON_IDENTITY = ["displayName", "userPrincipalName", "disN", "uPN"];
const WITH_AUTOMAPPING = ["withoutautomapping"];
const MAIL_PROPS = ["mail"];

const OBJECT_CLASS_PROPS: Record<string, string[]> = {
  computer: [...COMMON_IDENTITY, ...WITH_AUTOMAPPING],
  user: ["department", ...COMMON_IDENTITY, ...MAIL_PROPS, ...WITH_AUTOMAPPING],
  contact: ["displayName", ...MAIL_PROPS, "disN"],
  group: [...WITH_AUTOMAPPING],
};

export const mapMemberProperties = (member: any) => {
  const common = {
    newAddedFlag: true,
    parentOU: member.parentOU,
    distinguishedName: member.distinguishedName,
    name: member.name,
    cayoObjId: member.cayoObjId,
    userPrincipalName: member.userPrincipalName,
  };

  const extraProps = OBJECT_CLASS_PROPS[member.objectClass] || [];
  return { ...common, ...objectUtils.pickFromObject(member, extraProps) };
};
